define.alias("shared/components/shared/carousel/indicators", "settings/components/shared/carousel/indicators");